import React, { useState } from 'react';
// import GoogleMapReact from 'google-map-react';
import { withGoogleMap, GoogleMap, Marker,withScriptjs } from "react-google-maps"
import ReactTable from 'react-table';
import classnames from 'classnames';
import ReactTooltip from 'react-tooltip';
import async from 'async';
import { connect } from "react-redux";
import _ from 'lodash';
import DateTime from 'react-datetime';
import moment from 'moment';
import numeral from 'numeral';
import { Form, FormInput } from 'react-form';

import Dropzone from 'react-dropzone';
import GMap from './GMap';


import { Select, FormGroup, Text, Textarea2, Checkbox, DatePicker } from 'components/FormElements';
import { required, validFixedLine, email, validPhoneLEC, equalTo, greaterThan, dateGreaterThanNowYear } from 'constants/InputErrors';

import Translate from 'util/IntlMessages';
import IncmsService from 'services/IncmsService';
import IncmsNewConn from 'services/IncmsNewConnService'
import { toggleAlertError, toggleLoading } from 'stores/actions';
import APPCONFIG from 'constants/Config';
import { injectIntl } from "react-intl";
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';


const DisabledInput = ( { children } ) => (
  <div style={{ padding: '6.5px 10px', backgroundColor: '#F0F0F0' }}>{children}</div>
)
const ShadowBox = ( { children, style } ) => (
  <div className="p-3" style={{ boxShadow: 'rgba(0, 0, 0, 0.12) 0px 1px 12px', ...style }}>
    {children}
  </div>
)


const MyGreatPlace = ({ text }) => <div style={{
  // initially any map object has left top corner at lat lng coordinates
  // it's on you to set object origin to 0,0 coordinates
  position: 'absolute',
  width: 40,
  height: 40,
  left: -40 / 2,
  top: -40 / 2,

  border: '5px solid #f44336',
  borderRadius: 40,
  backgroundColor: 'white',
  textAlign: 'center',
  color: '#3f51b5',
  fontSize: 16,
  fontWeight: 'bold',
  padding: 4
}}>{text}</div>;

const numeralFormat = ( value ) => value ? numeral( value ).format( '0,0.[00]' ) : 0

class WorkRequest extends React.Component {
  constructor( props ) {
    super( props );

    this.state = {
      errorUpload: {},
      accountData: {},
      accounts: [],
      activeAccount: _.find( _.get( props.channel, 'accounts', [] ), { active: true } ),
      movements: [],
      nationalities: [],
      genders:[ {id:"M", description:"M"}, { id:"F", description:"F"} ],
      personalIdTypes:[],
      communities:[],
      districts:[],
      regionCounties:[],
      zones:[],
      streets:[],
      preferedBillDeliveryModes:[],
      voltageLevels:[],
      appliances:[],
      applianceCollection:[],
      phases:[],
      readingFrecuencies:[],
      premiseApplicationCapacities:[],
      premiseBuildingTypes:[],
      premiseSubActivities:[],
      premiseActivities:[],
      premiseCategories:[],
      premiseTypes:[],
      supplyTypes:[],
      appliances:[],
      customerTypes:[{id:'TC001', description:'Individual'}],
      documents:{},
      meterModalOpened: false,
      activityModalOpened: false,
      billModalOpened: false,
      billModalLECOpened: false,
      collectionModalOpened: false,
      mapModalOpened: false,
      tokenModalOpened: false,
      tokenModalLECOpened: false,
      movementFilterDateFrom: null,
      movementFilterDateTo: null,
      movementFilterType: null,
      outageInArea: false,
      latitude: 6.3192201,
      longitude: -10.806167 ,
      lecLat: 6.3192201,
      lecLng:-10.806167,
      nationality:'PD047',
      documentsGroupId: 1,
      defaultZoom:15,
      documentsGroup:[ {id:1, description: <Translate id="NationalIdAndProof"/>}, { id:2, description: <Translate id="TaxIdentification"/>} ],

    };
    this.submitForm = this.submitForm.bind( this );
    this.getData = this.getData.bind( this );
    this.onChange = this.onChange.bind(this);
    this.sendFileMessage = this.sendFileMessage.bind(this);
    this.handleChange = this.handleChange.bind(this);

  }

  componentDidMount() {
    this.getData()
  }

  getGeoData (){

    const { toggleLoading, toggleAlertError } = this.props;
    toggleLoading( true );
    async.parallel( {
      regionCountiesData: this.getCountries.bind( this ),
      districtsData: this.getProvinces.bind( this ),
      zonesData: this.getCities.bind( this ),
      communitiesData: this.getLocalities.bind( this ),
      streetsData: this.getStreet.bind( this ),
     
    }, ( error, results ) => {
      toggleLoading( false );
      if( error ) return toggleAlertError( error );

      this.setState( {
        regionCounties: results.regionCountiesData,
        districts: results.districtsData,
        zones: results.zonesData,
        communities: results.communitiesData,
        streets: results.streetsData,
      } )
    } )

  }


  getSubActivityData (){

    const { toggleLoading, toggleAlertError } = this.props;
    toggleLoading( true );
    async.parallel( {
      premiseSubActivitiesData: this.getSubActivities.bind( this ),

     
    }, ( error, results ) => {
      toggleLoading( false );
      if( error ) return toggleAlertError( error );

      this.setState( {
        premiseSubActivities: results.premiseSubActivitiesData,

      } )
    } )

  }


  getPremiseTypesCategoriesData (){

    const { toggleLoading, toggleAlertError } = this.props;
    toggleLoading( true );
    async.parallel( {
      premiseCategoriesData: this.getPremiseTypesCategories.bind( this ),

     
    }, ( error, results ) => {
      toggleLoading( false );
      if( error ) return toggleAlertError( error );

      this.setState( {
        premiseCategories: results.premiseCategoriesData,

      } )
    } )

  }

  



  getData() {
    const { activeAccount } = this.state;
    if( !activeAccount ) return;

    const { toggleLoading, toggleAlertError } = this.props;
    toggleLoading( true );

    async.parallel( {
      accountData: this.getAccountData.bind( this ),
      premiseApplicationCapacitiesData: this.getApplicationCapacity.bind( this ),
      premiseBuildingTypesData: this.getBuildings.bind( this ),
      premiseActivitiesData: this.getActivities.bind( this ),
  
    }, ( error, results ) => {
      toggleLoading( false );
      if( error ) return toggleAlertError( error );

      let accounts = _.get( results.accountData, 'OtherAccounts', [] ) || [];
      accounts = _.map( accounts, item => ( { id: item.OtherAccount, account: item.OtherAccount } ) );
      this.setState( {
        accountData: results.accountData,
        accounts: activeAccount ? [activeAccount, ...accounts] : [],
        premiseApplicationCapacities: results.premiseApplicationCapacitiesData,
        premiseBuildingTypes: results.premiseBuildingTypesData,
        premiseActivities: results.premiseActivitiesData,
      } )
    } )
  }

  getAccountData( cb ) {
    IncmsNewConn.getLecAccountData( this.state.activeAccount.account, this.props.locale ? this.props.locale.locale : 'en' )
      .then( ( response ) => {
        if( response.errors ) return cb( response.errors );
        cb( null, response.data )
      } )
  }

  getOutageInArea( cb ) {
    IncmsService.getClientFolderOutageArea( this.state.activeAccount.account )
      .then( ( response ) => {
        if( response.errors ) return cb();
        cb( null, response.data )
      } )
  }

  getCustomerDocumentTypes( cb ) {
    IncmsNewConn.getCustomerDocumentTypes( 
      this.state.customerType, 
      this.state.supplyType
    )
      .then( ( response ) => {
        if( response.errors ) return cb();
        cb( null, response.data )
      } )
  }

  getDocuments( cb ) {
    IncmsNewConn.getDocuments()
      .then( ( response ) => {
        if( response.errors ) return cb();
        cb( null, response.data )
      } )
  }

  getActivities( cb ) {
    const { activeAccount,customerTypes } = this.state;
    IncmsNewConn.getActivities( activeAccount.incmsDataobj.contractMask )
      .then( ( response ) => {
        if( response.errors ) return cb();
        cb( null, response.data )
      } )
  }
  getSubActivities( cb ) {
    const { activeAccount,customerTypes } = this.state;
    IncmsNewConn.getSubActivities( activeAccount.incmsDataobj.contractMask, this.state.premiseActivity)
      .then( ( response ) => {
        if( response.errors ) return cb();
        cb( null, response.data )
      } )
  }
  getBuildings( cb ) {
    const { activeAccount,customerTypes } = this.state;
    IncmsNewConn.getBuildings( activeAccount.incmsDataobj.contractMask, )
      .then( ( response ) => {
        if( response.errors ) return cb();
        cb( null, response.data )
      } )
  }
  getApplicationCapacity( cb ) {
    const { activeAccount,customerTypes } = this.state;
    IncmsNewConn.getApplicationCapacity( activeAccount.incmsDataobj.contractMask,  )
      .then( ( response ) => {
        if( response.errors ) return cb();
        cb( null, response.data )
      } )
  }

  addAppliance(e){
    this.setState ( prevState => (   { applianceCollection: [...prevState.applianceCollection, { } ] })   );
  }


  onChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  }
  submitForm( data ) {
    //const { onClose, onReloadData, toggleAlertError, toggleLoading } = this.props;
    const { toggleLoading, toggleAlertError, onReloadChannel, onClose } = this.props;
    const { documentsGroupId, activeAccount,accountData } = this.state;
    toggleLoading( true );
    const dataToSend={};
    dataToSend.supplyTypeId= _.get( accountData, 'supplyType.id', '' );
    dataToSend.supplyTypeContractMask = _.get( accountData, 'supplyType.contractMask', '' );
    dataToSend.supplyTypeDescription = _.get( accountData, 'supplyType.description', '' );
    dataToSend.customerId = this.props.activeAccount ? this.props.activeAccount.idCustomer.toString() : null; //50071229;
    //dataToSend.currentPower = data.currentPower;
    dataToSend.requiredPower = data.requestedPower;
    dataToSend.activity = data.premiseActivity.toString();
    dataToSend.subActivity = data.premiseSubActivity.toString();
    dataToSend.buildingType = data.premiseBuildingType.toString();
    dataToSend.applicationCapacity = data.premiseApplicationCapacity.toString();


    dataToSend.firstName= _.get( accountData, 'clientData.customerName', '-' );
    dataToSend.middleName= _.get( accountData, 'customerName.middleName', '-' );
    dataToSend.surname= _.get( accountData, 'clientData.surname', '-' );
    dataToSend.dateOfBirth= "31/12/1899";
    dataToSend.sex= _.get( accountData, 'clientData.sex', '-' );
    dataToSend.title= _.get( accountData, 'clientData.title', '-' );
    dataToSend.customerType= _.get( accountData, 'clientData.tipCli.id','-');
    dataToSend.occupation= '-';
    dataToSend.docType= _.get( accountData, 'clientData.tipDoc.id','-');
    dataToSend.nationalityId= '-';
    dataToSend.nationalityDescription= '-';
    dataToSend.docId= _.get( accountData, 'clientData.docId','-');
    dataToSend.idDescription= '-';
    dataToSend.emailAddress= activeAccount.incmsDataobj.email || "-";
    dataToSend.mobileNumber= _.get( accountData, 'clientData.tel','-');
    dataToSend.phone2= "-";
    dataToSend.phone3= "-";
    dataToSend.fax= "-";
    dataToSend.preferredMedia= "-";
    dataToSend.facebookUser= "-";
    dataToSend.twitterUser= "-";
    dataToSend.supplyTypeDescription= _.get( accountData, 'supplyType.description','-');
    dataToSend.contractNumber= this.props.activeAccount.account;
    dataToSend.contractSequenceNumber=  _.get( accountData, 'sequenceNumber',0);
    dataToSend.tariff= _.get( accountData, 'tarrif.id','-');
    dataToSend.enrollmentDate= "-";
    dataToSend.billingPeriod= _.get( accountData, 'billingPeriod.id','-');
    dataToSend.balance= _.get( accountData, 'balance',0);
    dataToSend.dispatchMethod= _.get( accountData, 'dispatchMethod.id','-');
    dataToSend.countryCode= _.get( accountData, 'premiseInformation.countrycode',0);
    dataToSend.provinceId= _.get( accountData, 'premiseInformation.provinceId',0);
    dataToSend.cityId= _.get( accountData, 'premiseInformation.cityId',0);
    dataToSend.localityId= _.get( accountData, 'premiseInformation.localityId',0);
    dataToSend.premiseId= _.get( accountData, 'premiseInformation.premiseId',0);
    dataToSend.streetId= _.get( accountData, 'premiseInformation.streetId',0);
    dataToSend.housePlotNumber= _.get( accountData, 'premiseInformation.housePlotNumber',0);
    dataToSend.landmark= _.get( accountData, 'premiseInformation.landmark','-');
    dataToSend.streetName= _.get( accountData, 'premiseInformation.streetName','-');
    dataToSend.district= _.get( accountData, 'premiseInformation.district','-');
    dataToSend.locality= _.get( accountData, 'premiseInformation.locality','-');
    dataToSend.provinceName= _.get( accountData, 'premiseInformation.provinceName','-');
    dataToSend.countryName= _.get( accountData, 'premiseInformation.countryName','-');
    dataToSend.cityName= _.get( accountData, 'premiseInformation.cityName','-');
    dataToSend.postShepId= _.get( accountData, 'servicePoint.postShepId',false);
    dataToSend.requestType= "SL020";
    dataToSend.contractType= _.get( accountData, 'requestData.contractType','-');
    dataToSend.powerFactor=  _.get( accountData, 'requestData.powerFactor',0);
    dataToSend.priority=  "PT001";

    dataToSend.documents=[];

    const documentKeyToSend = [ 
      "documentStatus",
      "documentType",
      "storageFilename",
      "originalFilename",
      "contentType",
      "description",
      "creationDate",
      "contentClass"
    ];

    if (_.hasIn( this.state.documents, 'CD001') && (documentsGroupId === 1 ))
      dataToSend.documents.push( _.pick( this.state.documents['CD001'], documentKeyToSend  ));
    if (_.hasIn( this.state.documents, 'CD017') && (documentsGroupId === 1 ))
      dataToSend.documents.push( _.pick( this.state.documents['CD017'], documentKeyToSend  ) );
    
    if (_.hasIn( this.state.documents, 'CD007') && (documentsGroupId === 2 ))
      dataToSend.documents.push( _.pick( this.state.documents['CD007'], documentKeyToSend  ) );

    if (_.hasIn( this.state.documents, 'CD018'))
      dataToSend.documents.push( _.pick( this.state.documents['CD018'], documentKeyToSend  ) );
    if (_.hasIn( this.state.documents, 'CD019'))
      dataToSend.documents.push( _.pick( this.state.documents['CD019'], documentKeyToSend  ) );

    
    IncmsNewConn.powerUpgrade( dataToSend ).then( ( response ) => {
      toggleLoading( false );
      if ( response.errors ) 
         return toggleAlertError( response.errors );

     toggleAlertError( `Work Request Code : ${response.data.requestData.requestId || '---'}`, response.data.requestData.requestId );
     
     onReloadChannel( );
     onClose()
    

    } )
  }

   sendFileMessage = ( documentType, file ) => {
    const { toggleLoading,toggleAlertError } = this.props;
    const {documents, errorUpload} = this.state;
    toggleLoading(true)

    IncmsNewConn.sendFile( { file } )
      .then( ( response ) => {
        toggleLoading(false)
        if( response.errors ) {
          toggleAlertError( response.errors )

          errorUpload[ documentType ] = true;
          this.setState( errorUpload );
          //return false

        }
        const wrdocument = response.data;
        if (wrdocument){
          wrdocument.documentType = documentType;
          documents[documentType] = wrdocument;
          this.allDocs = documents;
          errorUpload[ documentType ] = false;
          this.setState( errorUpload );
        } else {
          errorUpload[ documentType ] = true;
          this.setState( errorUpload );
        }
        
        //return true;
      } )

  }

  handleChange = (current, newValue) => {
    if (!!newValue)
    this.props.setTab(newValue)
  };

  render() {
    const {
      errorUpload,
      accountData, 
      accounts, 
      activeAccount, 
      movements, 
      movementFilterDateFrom, 
      movementFilterDateTo,
      nationalities,
      nationality,
      genders,
      gender,
      personalIdTypes,
      personalIdType,
      communities,
      community,
      districts,
      district,
      regionCounties,
      regionCounty,
      streets,
      street,
      zones,
      zone,
      customerTypes,
      customerType,
      preferedBillDeliveryModes,
      preferedBillDeliveryMode,
      voltageLevels,
      voltageLevel,
      phases,
      phase,
      readingFrecuencies,
      readingFrecuency,
      premiseApplicationCapacities,
      premiseApplicationCapacity,
      premiseBuildingTypes,
      premiseBuildingType,
      premiseSubActivities,
      premiseSubActivity,
      premiseActivities,
      premiseActivity,
      premiseCategories,
      premiseCategory,
      premiseTypes,
      premiseType,
      supplyType,
      supplyTypeId,
      supplyTypes,
      appliances,
      DeviceCode,
      DevicePower,
      DeviceNumber,
      applianceCollection,
      movementFilterType, 
      expiryDate,
      issueDate,
      dateOfBirth,
      longitude,
      latitude,
      lecLng,
      lecLat,
      defaultZoom,
      mobileNumber,
      firstName,
      middleName,
      surname,
      personalIdNumber,
      primaryEmail,
      confirmEmail,
      premiseName,
      premiseLandmark,
      premisePoleNumber,
      billCopies,
      phone2,
      phone3,
      facebookName,
      twitterName,
      note,
      fax,
      documentsGroup,
      documentsGroupId,
      documents,
      currentZoom,
      meterModalOpened, activityModalOpened,
      requestedPower,
      currentPower,
      billModalOpened, billModalLECOpened, collectionModalOpened, tokenModalOpened, tokenModalLECOpened, outageInArea, mapModalOpened
    } = this.state;
    
    const { dateFormat, externalCodes,googleMapKey, uploadFile, selectedTab } = this.props;
    const meters = _.get( accountData, 'ServicesList[0].MeterNumbers', [] );
    const contacts = _.get( accountData, 'Contact', [] );
    const movementTypes = _.chain( _.get( accountData, 'Movements', [] ) )
      .map( item => ( { id: item.MovementType, name: item.MovementType } ) ).uniqBy( 'id' ).value();
    
    
    const MyMapComponent = withScriptjs( withGoogleMap( (props) =>{
      const [currentZoom, setCurrentZoom] = useState(15);//default

      function handleZoomChanged() {
        
        props.handleZoom(this.getZoom());
        
      } 
    
    return (
      <GoogleMap
        onClick={props.addMarker}
        defaultZoom={props.defaultZoom}
        defaultCenter={{ lat: props.lat, lng: props.lng }}
        onZoomChanged={handleZoomChanged}
      >
        <Marker position={{ lat: props.lat, lng: props.lng}} />
      </GoogleMap>
    )
    }
    ))
    
    return (
      <div className="client-folder mb-5">
         <Form onSubmit={this.submitForm}
              defaultValues={{ 
                supplyType: supplyTypeId,
                nationality: nationality,
                customerType: customerType,
                mobileNumber: mobileNumber,
                fax:fax,
                phone2: phone2,
                phone3: phone3,
                facebookName: facebookName,
                twitterName: twitterName,
                note: note,
                firstName: firstName,
                middleName: middleName,
                surname: surname,
                dateOfBirth:dateOfBirth,
                nationality:nationality,
                expiryDate: expiryDate,
                personalIdNumber: personalIdNumber,
                issueDate: issueDate,
                personalIdType: personalIdType,
                customerType: customerType,
                gender:gender,
                primaryEmail: primaryEmail,
                confirmEmail: confirmEmail,
                regionCounty: regionCounty,
                district:district,
                zone: zone,
                community: community,
                street: street,
                premiseName: premiseName,
                premiseType: premiseType,
                premiseCategory: premiseCategory,
                premiseActivity: premiseActivity,
                premiseSubActivity: premiseSubActivity,
                premiseBuildingType: premiseBuildingType,
                premiseApplicationCapacity: premiseApplicationCapacity,
                premiseLandmark: premiseLandmark,
                premisePoleNumber: premisePoleNumber,
                readingFrecuency: readingFrecuency,
                phase: phase,
                preferedBillDeliveryMode:preferedBillDeliveryMode,
                billCopies:billCopies,
                documentsGroupId: documentsGroupId,
                voltageLevel:voltageLevel,
                requestedPower,
                currentPower,
                
              }}
              onValidationFail={() => {
                this.props.toggleAlertError( this.props.intl.formatMessage( { id: 'formValidationErrors' } ));
              }}
              validate={( values ) =>  {
                const VALIDATIONS =  {
                
                  premiseActivity: required( values.premiseActivity ),
                  premiseSubActivity: required( values.premiseSubActivity ),
                  premiseBuildingType: required( values.premiseBuildingType ),
                  premiseApplicationCapacity: required( values.premiseApplicationCapacity ),
                  // currentPower: required( currentPower ),
                  requestedPower: required( requestedPower ),
               
                } 

                return VALIDATIONS;
                }

                
              }

        >
        {( { getValue, setValue, removeValue, submitForm, getFormState } )=> 
        <form onSubmit={submitForm}>
        <div className="pb-0">
          <div className="row align-items-center mx-0">
            <div className="col-md">
              <h5>
                <Translate id="work_requests"/>
              </h5>
            </div>

          </div>
        </div>

        <Tabs value={selectedTab}  aria-label="Work Request" onChange={this.handleChange}>
          <Tab label={<Translate id="NewConnection"/>}  />
          <Tab label={<Translate id="ChangeOwnership"/>} />
          <Tab label={<Translate id="ChangeTenant"/>} />
          <Tab label={<Translate id="PowerUpgrade"/>} />
        </Tabs>
       
          <div className="pb-3" style={{ boxShadow: 'rgba(0, 0, 0, 0.12) 0px 1px 12px' }}>

            <div className="row align-items-center mx-0">
              <div className="col-md">
                <h5>
                  <Translate id="powerUpgrade"/>
                </h5>
              </div>
              <div className="col-md-auto d-flex align-items-center">

              </div>
            </div>

            <div className="row mx-0">
              <div className="col-md-12">

                <div className="row">

                <div className="col-md-4">
                    <FormGroup>
                      <label>
                        <Translate id="premiseActivity"/>
                      </label>
                      <Select
                        field="premiseActivity"
                        clearable={false}
                        onChange={( value ) => {
                          //const premiseActivity = _.find( premiseActivities, { id: value } );
                          //if( premiseActivity ) {
                            //setValue( value );
                            this.setState( { premiseActivity: value }, this.getSubActivityData )
                          //}
                        }}
                        options={premiseActivities}
                        className="form-control"
                        labelKey="description"
                        searchable={true}
                        value={premiseActivity}
                      />                     
                      </FormGroup>
                  </div>
                  <div className="col-md-4">
                    <FormGroup>
                      <label>
                        <Translate id="premiseSubActivity"/>
                      </label>
                      <Select
                        field="premiseSubActivity"
                        clearable={false}
                        onChange={( value ) => {
                          //const premiseSubActivity = _.find( premiseSubActivities, { id: value } );
                          //if( premiseSubActivity ) {
                            this.setState( { premiseSubActivity: value } )
                          //}
                        }}
                        options={premiseSubActivities}
                        className="form-control"
                        labelKey="description"
                        searchable={true}
                        value={premiseSubActivity}
                      />                       
                      </FormGroup>
                  </div>
                
                </div>
                <div className="row">

                <div className="col-md-4">
                    <FormGroup>
                      <label>
                        <Translate id="premiseBuildingType"/>
                      </label>
                      <Select
                        field="premiseBuildingType"
                        clearable={false}
                        onChange={( value ) => {
                          //const premiseBuildingType = _.find( premiseBuildingTypes, { id: value } );
                          //if( premiseBuildingType ) {
                            this.setState( { premiseBuildingType: value } )
                          //}
                        }}
                        options={premiseBuildingTypes}
                        className="form-control"
                        labelKey="description"
                        searchable={true}
                        value={premiseBuildingType}
                      />
                      </FormGroup>
                  </div>
                  <div className="col-md-4">
                    <FormGroup>
                      <label>
                        <Translate id="premiseApplicationCapacity"/>
                      </label>
                      <Select
                        field="premiseApplicationCapacity"
                        clearable={false}
                        onChange={( value ) => {
                          //const premiseApplicationCapacity = _.find( premiseApplicationCapacities, { id: value } );
                          //if( premiseApplicationCapacity ) {
                            this.setState( { premiseApplicationCapacity: value } )
                          //}
                        }}
                        options={premiseApplicationCapacities}
                        className="form-control"
                        labelKey="description"
                        searchable={true}
                        value={premiseApplicationCapacity}
                      />
                    </FormGroup>
                  </div>

                </div>

                <div className="row">

                  <div className="col-md-4">
                    <FormGroup>
                      <label>
                        <Translate id="requestedPower"/>
                      </label>
                      <Text field="requestedPower" className="form-control" onChange={( value ) => {  this.setState( { requestedPower: value }) }}/>
                    </FormGroup>
                  </div>
                </div>


              </div>

            </div>
          </div>

          <div className="pb-3" style={{ boxShadow: 'rgba(0, 0, 0, 0.12) 0px 1px 12px' }}>

            <div className="row align-items-center mx-0">
              <div className="col-md">
                <h5>
                  <Translate id="attachments"/>
                </h5>
              </div>
              <div className="col-md-auto d-flex align-items-center">

              </div>
            </div>
            <div className="row mx-0">
              <div className="col-md-12">

                <div className="row">
                  <div className="col-md-2">
                    <FormGroup>
                    <label>
                        <Translate id="documentsGroup"/>*
                    </label>
                    <Select
                        field="documentsGroupId"
                        clearable={false}
                        onChange={( value ) => {
                          //const preferedBillDeliveryMode = _.find( preferedBillDeliveryModes, { id: value } );
                          //if( preferedBillDeliveryMode ) {
                            this.setState( { documentsGroupId: value } )
                          //}
                        }}
                        options={documentsGroup}
                        className="form-control"
                        labelKey="description"
                        searchable={true}
                        value={documentsGroupId}
                      />                    
                    </FormGroup>
                  </div>
                  <div className="col-md-2">

                  </div>
                  <div className="col-md-2">

                  </div>
                </div>
              </div>

            </div>
            
            <div className="row mx-0">
              <div className="col-md-6">
                {documentsGroupId===1 &&
                <div className="row">
                  <div className="col-md-6">
                    <FormGroup>
                    <label>
                        <Translate id="nationalID"/>*
                    </label>
                    </FormGroup>
                  </div>
                  <div className="col-md-6">
                    <FormGroup>
                        {(errorUpload["CD001"] || !this.state.fileNationalId) &&
                          <Dropzone
                            className={classnames( 'd-inline', { disabled: false } )}
                            accept="application/pdf, .doc, .docx, image/*" disabled={false}
                            maxSize={1000000}
                            maxFiles={1}
                            onDrop={( files ) => {
                              if( files && files[0] ) {
                                const reader = new FileReader();
                                reader.onload = () => {
                                    // console.log("test");
                                    setValue( 'fileNationalId', getValue( 'fileNationalId' ) ? getValue( 'fileNationalId' )  : files )
                                    this.setState({fileNationalId : getValue( 'fileNationalId' ) ? getValue( 'fileNationalId' )  : files})
                                    this.sendFileMessage( "CD001", files[0] );

                                  
                                };
                                reader.readAsDataURL( files[0] );

                              }
                            }}
                            >
                            <i className="fa fa-paperclip mr-1"/>
                            <span className="color-gray-4 pointer font-weight-light"><Translate id="addAttachment"/></span>
                          </Dropzone>
                        }
                        
                          {!errorUpload["CD001"] && _.map( this.state.fileNationalId, ( file, index ) => {
                              return <div key={index}
                                          className="callout callout-info mx-0 my-2 p-2 d-flex justify-content-between">
                                {file.name}
                                <i className="fa icon-close pointer"
                                  onClick={() => { removeValue( 'fileNationalId', index ); this.setState({fileNationalId: null})  } }/>
                              </div>
                            }
                          )}
                        
                      </FormGroup>
                  </div>

                </div>
                }
                {documentsGroupId===1 &&
                <div className="row">
                  <div className="col-md-6">
                    <FormGroup>
                    <label>
                        <Translate id="proofOfOwnership"/>*
                    </label>
                    </FormGroup>
                  </div>
                  <div className="col-md-6">
                    <FormGroup>
                        {(errorUpload["CD017"] || !this.state.fileProofOfOwnership) &&
                        <Dropzone
                          className={classnames( 'd-inline', { disabled: false } )}
                          accept="application/pdf, .doc, .docx, image/*" disabled={false}
                          maxSize={1000000}
                          maxFiles={1}
                          onDrop={( files ) => {
                            if( files && files[0] ) {
                              const reader = new FileReader();
                              reader.onload = () => {
                                  this.sendFileMessage( "CD017", files[0] ) 
                                  setValue( 'fileProofOfOwnership', getValue( 'fileProofOfOwnership' ) ? getValue( 'fileProofOfOwnership' )  : files )
                                  this.setState({fileProofOfOwnership : getValue( 'fileProofOfOwnership' ) ? getValue( 'fileProofOfOwnership' )  : files})
                                
                              };
                              reader.readAsDataURL( files[0] );
                              
                            }
                          }}
                          >
                          <i className="fa fa-paperclip mr-1"/>
                          <span className="color-gray-4 pointer font-weight-light"><Translate id="addAttachment"/></span>
                        </Dropzone>
                      }
                      {!errorUpload["CD017"] && _.map( this.state.fileProofOfOwnership, ( file, index ) => {
                          return <div key={index}
                                      className="callout callout-info mx-0 my-2 p-2 d-flex justify-content-between">
                            {file.name}
                            <i className="fa icon-close pointer"
                              onClick={() => { removeValue( 'fileProofOfOwnership', index ); this.setState({fileProofOfOwnership: null})  } }/>
                          </div>
                        }
                      )} 
                    </FormGroup>
                  </div>

                </div>
                }

                {documentsGroupId===2 &&
                  <div className="row">
                    <div className="col-md-6">
                      <FormGroup>
                      <label>
                          <Translate id="TaxIdentification"/>*
                      </label>
                      </FormGroup>
                    </div>
                    <div className="col-md-6">
                      <FormGroup>
                        {(errorUpload["CD007"] || !this.state.fileTaxIdentification) &&
                          <Dropzone
                            className={classnames( 'd-inline', { disabled: false } )}
                            accept="application/pdf, .doc, .docx, image/*" disabled={false}
                            maxSize={1000000}
                            maxFiles={1}
                            onDrop={( files ) => {
                              if( files && files[0] ) {
                                const reader = new FileReader();
                                reader.onload = () => {
                                   this.sendFileMessage( "CD007", files[0] ) 
                                    setValue( 'fileTaxIdentification', getValue( 'fileTaxIdentification' ) ? getValue( 'fileTaxIdentification' )  : files )
                                    this.setState({fileTaxIdentification : getValue( 'fileTaxIdentification' ) ? getValue( 'fileTaxIdentification' )  : files})
                                 
                                };
                                reader.readAsDataURL( files[0] );

                              }
                            }}
                            >
                            <i className="fa fa-paperclip mr-1"/>
                            <span className="color-gray-4 pointer font-weight-light"><Translate id="addAttachment"/></span>
                          </Dropzone>
                        }
                        {!errorUpload["CD007"] && _.map( this.state.fileTaxIdentification, ( file, index ) => {
                            return <div key={index}
                                        className="callout callout-info mx-0 my-2 p-2 d-flex justify-content-between">
                              {file.name}
                              <i className="fa icon-close pointer"
                                onClick={() => { removeValue( 'fileTaxIdentification', index ); this.setState({fileTaxIdentification: null})  } }/>
                            </div>
                          }
                        )} 
                      </FormGroup>
                    </div>

                  </div>
                }

                <div className="row">
                  <div className="col-md-6">
                    <FormGroup>
                    <label>
                        <Translate id="sketchMap"/>
                    </label>                      

                    </FormGroup>
                  </div>
                  <div className="col-md-6">
     
                      <FormGroup>
                        {(errorUpload["CD018"] || !this.state.fileSketchMap) &&
                          <Dropzone
                            className={classnames( 'd-inline', { disabled: false } )}
                            accept="application/pdf, .doc, .docx, image/*" disabled={false}
                            maxSize={1000000}
                            maxFiles={1}
                            onDrop={( files ) => {
                              if( files && files[0] ) {
                                const reader = new FileReader();
                                reader.onload = () => {
                                    this.sendFileMessage( "CD018", files[0] ) 
                                    setValue( 'fileSketchMap', getValue( 'fileSketchMap' ) ? getValue( 'fileSketchMap' )  : files )
                                    this.setState({fileSketchMap : getValue( 'fileSketchMap' ) ? getValue( 'fileSketchMap' )  : files})
                                  

                                };
                                reader.readAsDataURL( files[0] );


                              }
                            }}
                            >
                            <i className="fa fa-paperclip mr-1"/>
                            <span className="color-gray-4 pointer font-weight-light"><Translate id="addAttachment"/></span>
                          </Dropzone>
                        }

                        {!errorUpload["CD018"] && _.map( this.state.fileSketchMap, ( file, index ) => {
                            return <div key={index}
                                        className="callout callout-info mx-0 my-2 p-2 d-flex justify-content-between">
                              {file.name}
                              <i className="fa icon-close pointer"
                                onClick={() => { removeValue( 'fileSketchMap', index ); this.setState({fileSketchMap: null})  } }/>
                            </div>
                          }
                        )} 
                      </FormGroup>
                  </div>

                </div>

                <div className="row">
                  <div className="col-md-6">
                    <FormGroup>
                    <label>
                        <Translate id="annualDemandDeclaration"/>
                    </label>                      

                    </FormGroup>
                  </div>
                  <div className="col-md-6">
                      <FormGroup>
                        {(errorUpload["CD019"] || !this.state.fileAnnualDemandDeclaration) &&
                          <Dropzone
                            className={classnames( 'd-inline', { disabled: false } )}
                            accept="application/pdf, .doc, .docx, image/*" disabled={false}
                            maxSize={1000000}
                            maxFiles={1}
                            onDrop={( files ) => {
                              if( files && files[0] ) {
                                const reader = new FileReader();
                                reader.onload = () => {
                                    this.sendFileMessage( "CD019", files[0] ) 
                                    setValue( 'fileAnnualDemandDeclaration', getValue( 'fileAnnualDemandDeclaration' ) ? getValue( 'fileAnnualDemandDeclaration' )  : files )
                                    this.setState({fileAnnualDemandDeclaration : getValue( 'fileAnnualDemandDeclaration' ) ? getValue( 'fileAnnualDemandDeclaration' )  : files})
 
                                  
                                };
                                reader.readAsDataURL( files[0] );

                             }
                            }}
                            >
                            <i className="fa fa-paperclip mr-1"/>
                            <span className="color-gray-4 pointer font-weight-light"><Translate id="addAttachment"/></span>
                          </Dropzone>
                        }

                        {!errorUpload["CD019"] && _.map( this.state.fileAnnualDemandDeclaration, ( file, index ) => {
                            return <div key={index}
                                        className="callout callout-info mx-0 my-2 p-2 d-flex justify-content-between">
                              {file.name}
                              <i className="fa icon-close pointer"
                                onClick={() => { removeValue( 'fileAnnualDemandDeclaration', index ); this.setState({fileAnnualDemandDeclaration: null})  } }/>
                            </div>
                          }
                        )} 
                        </FormGroup>
                  </div>
 
                </div>

              </div>

              <div className="col-md-6">
                <div className="row">
                  <div className="col-md-12">
                    <b>Important Information!</b>
                    <p>
                    Please ensure that you have the required mandatory document(s) below:
                      <ol> 
                        <li>PROOF OF OWNERSHIP</li>
                        <li>PERSONAL IDENTITY DOCUMENT</li>
                        <li>or TAX IDENTIFICATION NUMBER.</li>
                      </ol>
                    </p>

                  </div>
                </div>
              </div>

            </div>
          </div> 
          
          <div className="text-center pt-3">
                <button className="btn btn-info" ><Translate id="submit"/></button>
          </div>
        </form>
      }
      </Form>

      </div>
    )
  }
}

const mapStateToProps = ( state, ownProps ) => ( {
  locale: state.settings.locale,
  dateFormat: state.settings.dateFormat,
  externalCodes: state.settings.externalCodes,
  googleMapKey: state.settings.googleMapKey,
  uploadFile: state.settings.uploadFile,
} );


const mapDispatchToProps = dispatch => ( {
  toggleAlertError: ( message, msgToCopy ) => {
    dispatch( toggleAlertError( message, msgToCopy ) );
  },
  toggleLoading: ( isLoading ) => {
    dispatch( toggleLoading( isLoading ) );
  },
} );
export default injectIntl( connect( mapStateToProps, mapDispatchToProps )( WorkRequest ) );



// WEBPACK FOOTER //
// ./routes/app/components/Agent/WorkRequestPowerUpgrade/index.js